import { combineReducers } from "redux";
import personalInfo from "./physician/personalInfo";
import practiceDetails from "./physician/practiseDetails";
import documents from "./physician/documents";
import personalisedExperience from "./physician/personalisedExperience";
import patientPersonalInfo from "./patient/patientPersonalInfo";
import medicalRecord from "./patient/medicalRecord";
import accountDetails from "./physician/accountDetails";

const onboarding = combineReducers({
  personalInfo,
  practiceDetails,
  documents,
  personalisedExperience,
  patientPersonalInfo,
  medicalRecord,
  accountDetails,
});

export default onboarding;
